import React, { useEffect, useState } from "react";
import { Form, Row, Col, } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { getFeeCollection, getDemandReport, getDueReport, getDiscountReport, gettransportReport } from "../../store/slices/fees";
import { toast } from "react-hot-toast";
import { FiHome, FiChevronRight } from "react-icons/fi";
import { fetchStandardSection } from "../../store/slices/getstandardsection";
import { pdf } from "@react-pdf/renderer";
import CollectionReport from "../admin/collectionReport";
import DemandReport from "../admin/demandReport";
import DueReport from "../admin/dueReport";
import DiscountReport from "../admin/discountReport";
import TransportCollectionReport from "../admin/transportReport";

export default function Report() {
  const dispatch = useDispatch();
  const currentYear = new Date().getFullYear();
  const [errors, setErrors] = useState({});

  const sessions = Array.from({ length: 2 }, (_, index) => {
    const startYear = currentYear - 1 + index;
    const endYear = String(startYear + 1).slice(-2);

    return `${startYear}-${endYear}`;
  });

  const [session, setSession] = useState("");
  const [standardId, setStandardId] = useState("");

  const [sectionId, setSectionId] = useState("");
  const [standards, setStandards] = useState([]);
  const [sections, setSections] = useState([]);
  const [reportType, setReportType] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const today = new Date().toISOString().split("T")[0];

  useEffect(() => {

    dispatch(fetchStandardSection())
      .unwrap()
      .then((res) => {

        setStandards(res.data || []);

      })
      .catch((err) => {

        toast.error(err);

      });

  }, []);

  const validate = () => {

    const newErrors = {};

    if (!session)
      newErrors.session = "Please select session";

    if (!reportType)
      newErrors.reportType = "Please select report type";

    if (["collection", "transport"].includes(reportType)) {

      if (!fromDate)
        newErrors.fromDate = "Please select from date";

      if (!toDate)
        newErrors.toDate = "Please select to date";

    }

    if (["demand", "due", "discount"].includes(reportType)) {

      if (sectionId && !standardId) {
        newErrors.standardId =
          "Please select standard first";
      }

    }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;

  };
  const handleStandardChange = (e) => {

    const value = e.target.value;

    setStandardId(value);
    setSectionId("");

    setErrors((prev) => ({
      ...prev,
      standardId: "",
      sectionId: "",
    }));

    if (!value) {
      setSections([]);
      return;
    }

    const selectedStandard = standards.find(
      (item) => item.standardId._id === value
    );

    if (selectedStandard) {
      setSections(selectedStandard.sectionId || []);
    } else {
      setSections([]);
    }

  };
  const handleSearch = (e) => {

    e.preventDefault();

    if (!validate())
      return;

    switch (reportType) {

      case "collection":

        dispatch(getFeeCollection({
          session,
          fromDate,
          toDate
        }))
          .unwrap()
          .then(async (res) => {

            const blob = await pdf(
              <CollectionReport
                report={res}

                fromDate={fromDate}
                toDate={toDate}
              />
            ).toBlob();

            const url = URL.createObjectURL(blob);

            window.open(url, "_blank");

          })
          .catch((err) => {
            toast.error(err);
          });
        break
      case "transport":

        dispatch(gettransportReport({
          session,
          fromDate,
          toDate
        }))
          .unwrap()
          .then(async (res) => {

            const blob = await pdf(
              <TransportCollectionReport
                report={res}
                fromDate={fromDate}
                toDate={toDate}
              />
            ).toBlob();

            const url = URL.createObjectURL(blob);

            window.open(url, "_blank");

          })
          .catch((err) => {
            toast.error(err);
          });
        break

      case "demand":

        dispatch(
          getDemandReport({
            session,
            standardId,
            sectionId
          })
        )
          .unwrap()
          .then(async (res) => {

            const blob = await pdf(
              <DemandReport
                report={res}
                standardId={standardId}
                sectionId={sectionId}
              />
            ).toBlob();

            const url = URL.createObjectURL(blob);

            window.open(url, "_blank");

          })
          .catch((err) => {

            toast.error(err);

          });

        break;

      case "due":

        dispatch(
          getDueReport({
            session,
            standardId,
            sectionId
          })
        )
          .unwrap()
          .then(async (res) => {

            const blob = await pdf(
              <DueReport
                report={res}
                standardId={standardId}
                sectionId={sectionId}
              />
            ).toBlob();

            const url = URL.createObjectURL(blob);

            window.open(url, "_blank");

          })
          .catch((err) => {

            toast.error(err);

          });

        break;

      case "discount":

        dispatch(
          getDiscountReport({
            session,
            standardId,
            sectionId
          })
        )
          .unwrap()
          .then(async (res) => {

            const blob = await pdf(
              <DiscountReport
                report={res}
                standardId={standardId}
                sectionId={sectionId}
              />
            ).toBlob();

            const url = URL.createObjectURL(blob);

            window.open(url, "_blank");

          })
          .catch((err) => {

            toast.error(err);

          });

        break;

      default:
        break;
    }

  };



  return (
    <>
      <div className="page-header">
        <div className="breadcrumb-section">
          <div className="breadcrumb-left">
            <div className="home-icon">
              <Link to="/accounts/home">
                <FiHome style={{ color: "white", marginTop: "-4px" }} />
              </Link>
            </div>
            <FiChevronRight className="separator" />

            <span className="active">Reports</span>
          </div>
        </div>
      </div>
      <div className="acs-card">
        <Form onSubmit={handleSearch}>
          <Row className="g-3 align-items-end">

            {/* Session */}
            <Col md={3}>
              <Form.Group>
                <Form.Label>Session</Form.Label>
                <Form.Select
                  value={session}
                  onChange={(e) => {
                    setSession(e.target.value);
                    setErrors((prev) => ({
                      ...prev,
                      session: "",
                    }));
                  }}
                >
                  <option value="">Select Session</option>

                  {sessions.map((item) => (
                    <option key={item} value={item}>
                      {item}
                    </option>
                  ))}

                </Form.Select>
                <div className="text-danger mt-1" >
                  {errors.session}
                </div>
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group>
                <Form.Label>Report Type</Form.Label>
                <Form.Select
                  value={reportType}
                  onChange={(e) => {
                    setReportType(e.target.value);

                    setStandardId("");
                    setSectionId("");
                    setFromDate("");
                    setToDate("");

                    setErrors((prev) => ({
                      ...prev,
                      reportType: "",
                      standardId: "",
                      sectionId: "",
                      fromDate: "",
                      toDate: "",
                    }));
                  }}
                >
                  <option value="">Select Report Type</option>
                  <option value="collection">Collection Report</option>
                  <option value="transport">Transport Collection Report</option>
                  <option value="demand">Demand Report</option>
                  <option value="due">Due Report</option>
                  <option value="discount">Discount Report</option>
                </Form.Select>
                <div className="text-danger mt-1" >
                  {errors.reportType}
                </div>
              </Form.Group>
            </Col>
            {["demand", "due", "discount"].includes(reportType) && (
              <>
                <Col md={3}>
                  <Form.Group>
                    <Form.Label>Standard</Form.Label>

                    <Form.Select
                      value={standardId}
                      onChange={handleStandardChange}
                    >
                      <option value="">All Standards</option>

                      {standards.map((item) => (
                        <option
                          key={item.standardId._id}
                          value={item.standardId._id}
                        >
                          {item.standardId.name}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>

                <Col md={3}>
                  <Form.Group>
                    <Form.Label>Section</Form.Label>

                    <Form.Select
                      value={sectionId}
                      disabled={false}
                      onChange={(e) => {
                        setSectionId(e.target.value);

                        setErrors((prev) => ({
                          ...prev,
                          sectionId: "",
                        }));
                      }}
                    >
                      <option value="">All Sections</option>

                      {sections.map((item) => (
                        <option
                          key={item._id}
                          value={item._id}
                        >
                          {item.name}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
              </>
            )}


            {["collection", "transport"].includes(reportType) && (
              <>
                <Col md={3}>
                  <Form.Group>
                    <Form.Label>From Date</Form.Label>

                    <Form.Control
                      type="date"
                      value={fromDate}
                      max={today}
                      onChange={(e) => {
                        setFromDate(e.target.value);

                        setErrors((prev) => ({
                          ...prev,
                          fromDate: "",
                        }));
                      }}
                    />
                  </Form.Group>
                </Col>

                <Col md={3}>
                  <Form.Group>
                    <Form.Label>To Date</Form.Label>

                    <Form.Control
                      type="date"
                      value={toDate}
                      max={today}
                      min={fromDate}
                      onChange={(e) => {
                        setToDate(e.target.value);

                        setErrors((prev) => ({
                          ...prev,
                          toDate: "",
                        }));
                      }}
                    />
                  </Form.Group>
                </Col>
              </>
            )}
            <Col md={1}>
              <button
                type="submit"
                className="btn-submit"
                style={{ width: "150px" }}
              >
                Search
              </button>
            </Col>


          </Row>

        </Form>
      </div>
    </>
  );
}